import React, { useEffect } from "react";
import MdalDataType from "Interface/MdalDataType.interface";

import 'Assets/css/GameMdal.css';
import { Link } from "react-router-dom";


const GameLnchMdalUi = ({gameMainPageInfoState, onClose,langData}:any) => {
    // 모달 자동 닫기 시간 (밀리초) - 환경변수에서 가져오기
    const AUTO_CLOSE_TIME = parseInt(process.env.REACT_APP_GAME_MODAL_AUTO_CLOSE_TIME || '60000');
    
    // 자동 닫기 타이머 설정
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, AUTO_CLOSE_TIME);
        
        // 컴포넌트 언마운트 시 타이머 정리
        return () => clearTimeout(timer);
    }, [onClose]);
    
    const MdalDownloadFunc = () => {
        // Mac/Windows 환경에 따라 다른 다운로드 URL 사용
        const platform = navigator.platform.toLowerCase();
        const userAgent = navigator.userAgent.toLowerCase();
        
        const isMac = platform.includes('mac') || 
                     platform.includes('darwin') || 
                     userAgent.includes('mac') || 
                     userAgent.includes('macintosh') ||
                     userAgent.includes('darwin');
        
        const downloadUrl = isMac 
            ? gameMainPageInfoState?.gameSvcUiInfo?.macLnchDwnldUrl 
            : gameMainPageInfoState?.gameSvcUiInfo?.winLnchDwnldUrl;
        
        window.location.href = downloadUrl;
        onClose();
    }

    return(
        <>
            <div className='mdalCommWrap'>
                <div className='mdalBg' onClick={onClose}></div>
                <div className='mdalCommContainer mdalCustomContainer gameLnchMdal'>
                    <div className='mdalCommCloseBtn' onClick={onClose}><i className="close"></i></div>
                    <div className="mdalCtxtInfo">
                        <img src="https://bb-cdn.onuniverse.io/BBO/LIVE/RES/BEARBRICK-logo.png" alt="" style={{maxWidth:"185px"}}></img>
                        <p className="mdalTitl">{langData?.GAME_LNCH_MDAL_TITL_00}</p>
                        <div className="mdalDownCtxt">
                            <p dangerouslySetInnerHTML={{__html: langData?.GAME_LNCH_MDAL_CTXT_00 || ''}}></p>
                        </div>
                    </div>
                    <Link to="/gamepage/download?gameSvcCd=BBO"className='mdalCommAgreeBtn' onClick={() => onClose()}>
                           {langData?.GAME_LNCH_MDAL_BTN_00}
                    </Link>
                    
                </div>
            </div>
        </>
    )
}

export default GameLnchMdalUi;